import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8 3.16669L8 13.8334M8 13.8334L12 9.83335M8 13.8334L4 9.83335", stroke: "#222222", strokeWidth: 1.6, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgArrowDown);
export default ForwardRef;
